import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './style.scss'

const Loader = ({ kind, size, extraClasses }) => {
  const childrenCount = {
    ring: 4,
    roller: 8
  }

  const count = childrenCount[kind]

  return (
    <div
      className={classnames('fil-loader-wrapper', extraClasses, {
        [`fil-loader--${kind}`]: kind
      })}
      style={{ fontSize: `${size}px` }}
    >
      {[...Array(count).keys()].map((c) => (
        <div key={`fil-loader-child-${c}}`} />
      ))}
    </div>
  )
}

Loader.propTypes = {
  kind: PropTypes.string,
  size: PropTypes.number,
  extraClasses: PropTypes.string
}

Loader.defaultProps = {
  kind: 'ring',
  size: 16,
  extraClasses: ''
}

export default Loader
